import { adminInstance } from "@/api/instance";

export default async function (reviewId) {
  return adminInstance.get(`/review/${reviewId}`);
}
